const data = {
  p1: {
    title: "交互式IP解决方案",
    subtitle: "激活 IP 角色，突破次元壁边界，构建沉浸式交互体验"
  },
  p2: {
    title: "AI+IP\n一站式解决方案",
    desc: "从创意企划到交互式IP场景落地变现，提供全链路解决方案。无论是AI赋能经典IP重焕时代活力，还是新创IP全生命周期孵化运营，我们将助力客户突破虚拟角色与真实世界的边界，构建沉浸式交互体验，营造第三商业增长曲线。",
    texts: [
      { title: "创意内容企划" },
      { title: "IP活化" },
      { title: "交互式IP产品设计" },
      { title: "技术开发" },
      { title: "场景落地" }
    ],
    img: "p2Img"
  },
  p3: {
    title: "应用案例",
    cases: [
      {
        title: "《喜羊羊与灰太狼》《开心超人》数字人应用小程序矩阵",
        desc: "通过业界领先的数字人技术让喜羊羊等经典IP在《绵绵喜话》《羊言羊语》《火花杂物社》小程序中焕然新生。“分身有术”的他们跨越次元与用户相遇，在便捷易用的趣味互动中，绽放于数字生活新场景。为用户打造便捷且富有沉浸感的互动体验，重新定义IP在数字时代的生命力表达。",
        icons: ["p3Card1Icon1"],
        imgs: ["p3img1", "p3img2", "p3img3"]
      },
      {
        title: "交互式IP与应用平台跨界合作",
        desc: [
          { strong: true, text: "《喜羊羊与灰太狼》数字人×高德地图" },
          { text: "喜羊羊、懒羊羊、灰太狼数字人化身萌趣3D车标，让导航不再单调枯燥，亲切有趣生动的智能语音播报路况，还可以实时与数字人语音交互，将每一次旅程都变成温情满载的奇遇。目前已累计服务超百万出行用户。" },
          {
            text: <br />
          },
          { strong: true, text: "喜羊羊数字人×咪咕音乐" },
          { text: "在咪咕音乐，喜羊羊数字人不仅与你谈天说地，更能一键变身专属唱跳艺人，生成独一无二的“AI喜羊羊视频彩铃”，玩转“AI+IP”视频彩铃的新范式。" }
        ],
        icons: ["p3Card2Icon1", "p3Card2Icon2"],
        imgs: ["p3Img4"]
      },
      {
        title: "智能玩具",
        desc: "与奥飞娱乐联合打造的喜羊羊超能铃铛与AI智趣喜羊羊，通过\"硬件+算法+内容\"三位一体架构，实现\"能听会说、懂情绪、会成长\"的深度陪伴，以科技温度构建跨年龄层的情感连接，在点滴互动中编织有温度的情感纽带，诠释“智能陪伴”与“童趣创新”的无限可能。",
        icons: ["p3Card3Icon1"],
        imgs: ["p3img5", "p3img6"]
      }
    ]
  }
};
export default data;
